import React from 'react';
import ListBulletedIcon from '@atlaskit/icon/core/list-bulleted';
import ChevronRightIcon from '@atlaskit/icon/utility/chevron-right';
import { ButtonItem } from '@atlaskit/menu';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export function ShowMenuItem() {
	const { formatMessage } = useIntl();
	const onShowMenuItemClick = () => {
		// add logic in BLU-6618
	};
	return (
		<ButtonItem
			iconBefore={
				<ListBulletedIcon
					label={formatMessage(messages.listBulletedIcon)}
					spacing="spacious"
					color={token('color.icon')}
				/>
			}
			iconAfter={<ChevronRightIcon label={formatMessage(messages.chevronRightIcon)} />}
			onClick={onShowMenuItemClick}
			aria-label={formatMessage(messages.showMenuItemLabel)}
		>
			{formatMessage(messages.showMenuItemLabel)}
		</ButtonItem>
	);
}
